import React from 'react';
import {Outlet} from 'react-router-dom';
import AdminLayout from "../../../layout/admin/AdminLayout";

const OrganizationalUnits: React.FC = () => {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
};

export default OrganizationalUnits;
